import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const FirmwaresIndex = lazy(() => import('../../container/pages/firmwares/all-index'));

function FirmwaresRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<FirmwaresIndex />} />
    </Routes>
  );
}

export default FirmwaresRoutes;
